import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  tableCellClasses,
  tableSortLabelClasses,
  type TableProps,
} from '@mui/material';
import type { CSSProperties, ReactNode } from 'react';

export type AppTableColumnWidth = string | number | undefined;

type AppTableProps = TableProps & {
  columnWidths?: AppTableColumnWidth[];
  children?: ReactNode;
};

function colStyle(width: AppTableColumnWidth): CSSProperties | undefined {
  if (width === undefined) {
    return undefined;
  }
  return { width };
}

const AppTableRoot = ({ columnWidths, children, ...props }: AppTableProps) => (
  <Table {...props}>
    {columnWidths && (
      <colgroup>
        {columnWidths.map((width, index) => (
          <col key={index} style={colStyle(width)} />
        ))}
      </colgroup>
    )}
    {children}
  </Table>
);

type AppTableNamespace = typeof AppTableRoot & {
  TableContainer: typeof TableContainer;
  Thead: typeof TableHead;
  Tbody: typeof TableBody;
  Tr: typeof TableRow;
  Th: typeof TableCell;
  Td: typeof TableCell;
  SortLabel: typeof TableSortLabel;
  Pagination: typeof TablePagination;
};

export const AppTable: AppTableNamespace = Object.assign(AppTableRoot, {
  TableContainer,
  Thead: TableHead,
  Tbody: TableBody,
  Tr: TableRow,
  Th: TableCell,
  Td: TableCell,
  SortLabel: TableSortLabel,
  Pagination: TablePagination,
});

export { tableCellClasses, tableSortLabelClasses };
